
// this file is automatically generated by version.ts script
export const versions = {
  revision: 'c8462ab2e1dfebbc33514639a9f7b50ffae8385c',
  version: '1.124.0',
};
